module.exports = __webpack_public_path__ + "img/ltkswim-1x.e409bb2.jpg";